module.exports = __webpack_public_path__ + "be94a9a04b74f01727178d2509bb95df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/samsung_gear_connect/img-gear@2x.png
// module id = 1841
// module chunks = 1